import React from "react";

import ComponentCard from "./ComponentCard";


class EntityComponentCard extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return(
            <ComponentCard
                entity={this.props.componentObj.entity}
                entity_id={this.props.componentObj.entity_id}
                mini={this.props.mini}
                nano={this.props.nano}
            />
        )
    }
}

export default EntityComponentCard
